import React, { FC } from 'react';
import MainTitle from 'modules/shared/components/main-title';
import WidgetProductSliderMobile from 'modules/shared/widgets/components/widget-product-slider/widget-product-slider-mobile';
import { CatProductsDsData } from 'modules/shared/widgets/interfaces/datasources/cat-products-ds-data.interface';

import './home-products-carousel-mobile.scss';

interface HomeProductsCarouselMobileProps {
    categoryProducts: CatProductsDsData;
    isBot: boolean;
}

const HomeProductsCarouselMobile: FC<HomeProductsCarouselMobileProps> = ({ categoryProducts, isBot }) => {
    if (!categoryProducts) {
        return null;
    }

    return (
        <div className="home-products-carousel-mobile">
            <MainTitle
                htmlTag="h2"
                text={categoryProducts.category.name}
            />
            <WidgetProductSliderMobile
                data={categoryProducts}
                isBot={isBot}
            />
        </div>
    );
};

export default HomeProductsCarouselMobile;
